import { JobList, useFilter, useJobList, useMap } from 'rwl-ui';
import { isNotEmpty, isEmpty } from '@realwork/shared';
import { EmptyJobList } from './EmptyJobList';

export const JobListContainer = (): JSX.Element => {
    const { jobList } = useJobList();
    const { appliedFilters } = useFilter();
    const { bounds } = useMap();
    if ((isNotEmpty(appliedFilters) || bounds) && isEmpty(jobList)) {
        return <EmptyJobList />;
    }
    return <JobList />;
};
